import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import Vue from 'vue'
import { translate } from "autoprefixer/lib/hacks/grid-utils";

const state = {
  statuses: [
    { id: 1, name: 'wellbeing.leads.statuses.1' },
    { id: 2, name: 'wellbeing.leads.statuses.2' },
    { id: 3, name: 'wellbeing.leads.statuses.3' },
    { id: 4, name: 'wellbeing.leads.statuses.4' },
  ],
  appointmentPreferences: [
    {id: 1, value: 'start_of_day', translate: 'wellbeing.appointmentPreferences.start_of_day'},
    {id: 2, value: 'mid_morning', translate: 'wellbeing.appointmentPreferences.mid_morning'},
    {id: 3, value: 'end_of_morning', translate: 'wellbeing.appointmentPreferences.end_of_morning'},
    {id: 4, value: 'early_afternoon', translate: 'wellbeing.appointmentPreferences.early_afternoon'},
    {id: 5, value: 'mid_afternoon', translate: 'wellbeing.appointmentPreferences.mid_afternoon'},
    {id: 6, value: 'end_of_day', translate: 'wellbeing.appointmentPreferences.end_of_day'}
  ],
  simptomsOptions: [
    {id: 1, translate: 'wellbeing.simptoms.abdominal_bloating'},
    {id: 2, translate: 'wellbeing.simptoms.difficult_digestions'},
    {id: 3, translate: 'wellbeing.simptoms.constipation'},
    {id: 4, translate: 'wellbeing.simptoms.frequent_diarrhea' },
    {id: 5, translate: 'wellbeing.simptoms.excessive_flatulence'},
    {id: 6, translate: 'wellbeing.simptoms.heartburn'},
    {id: 7, translate: 'wellbeing.simptoms.gastroesophageal_reflux'},
    {id: 8, translate: 'wellbeing.simptoms.overweight'},
    {id: 9, translate: 'wellbeing.simptoms.joint_muscle_pain'},
    {id: 10 , translate: 'wellbeing.simptoms.low_energy_levels'}
  ],
  genderOptions: [
    {id: 1, translate: 'wellbeing.leads.genders.male', value: 'male'},
    {id: 2, translate: 'wellbeing.leads.genders.female', value: 'female'}
  ]
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
